import { WA_LINK } from "@/components/site/content";

export const WaIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.8h-.01a9.87 9.87 0 01-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 01-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88a9.83 9.83 0 016.99 2.9 9.82 9.82 0 012.9 6.99c0 5.45-4.44 9.88-9.9 9.88zm8.42-18.3A11.82 11.82 0 0012.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 005.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.16-3.48-8.41z" />
  </svg>
);

export const WaButton = ({ children, testid, size = "md" }) => (
  <a href={WA_LINK} data-testid={testid}
    className={`inline-flex items-center gap-2.5 rounded-md bg-[#25a244] text-white font-bold shadow-lg shadow-green-900/40 hover:bg-[#1e8a39] hover:-translate-y-0.5 transition-[transform,background-color] ${
      size === "lg" ? "px-8 py-4 text-lg" : "px-6 py-3"}`}>
    <WaIcon /> {children}
  </a>
);

export const StickyCta = () => (
  <div className="fixed bottom-0 inset-x-0 z-40 bg-black/90 backdrop-blur border-t border-white/10 py-2.5 flex justify-center gap-3" data-testid="sticky-cta">
    <a href={WA_LINK} data-testid="sticky-get-id-button" className="da-btn-purple px-6 py-2.5 text-sm">Get Your ID Now!</a>
    <a href={WA_LINK} data-testid="sticky-demo-id-button" className="da-btn-purple px-6 py-2.5 text-sm">Get Demo ID!</a>
  </div>
);

export const FloatingWhatsApp = () => (
  <a href={WA_LINK} data-testid="floating-whatsapp-button" aria-label="Chat on WhatsApp"
    className="fixed right-5 bottom-20 z-40 flex items-center gap-2 rounded-full bg-[#1daa61] text-white pl-4 pr-5 py-3 font-semibold shadow-xl hover:bg-[#178f51] transition-colors">
    <span className="relative flex">
      <span className="absolute inset-0 rounded-full bg-white/50 animate-ping" />
      <WaIcon className="relative w-6 h-6" />
    </span>
    <span className="hidden sm:inline">Live Chat Online</span>
  </a>
);
